module.exports = __webpack_public_path__ + "media/img/timesheet_authorisers/reset-pin-lock-055c672de547caf504c8de46602d69ce.svg";